import { citySlug } from '@/marketplace/format';

/** "Studio Força" → "studioforca": the address label suggested from a brand name. */
export function toLabel(name: string) {
  return citySlug(name).replace(/-/g, '').slice(0, 40);
}
